/**
 * @description: 库存不足是否出货
 * @author: hwx
 */
<template>
	<div class="shipment-manage-wrap">
		<div class="spmt-list" v-show="showSpmt">
			<div class="row rowmagin">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="addSpmt">新增设置</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="spmtList"></table>
			</div>
		</div>
		<div class="spmt-edit" ref="spmt_edit">
			<div class="row">
				<label class="col-md-4">门店：</label>
				<div class="col-md-8 ct-col">
					<select class="form-control" data-placeholder="请选择门店" ref="spmt_edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="col-md-4">仓库名称：</label>
				<div class="col-md-8 ct-col">
					<select class="form-control" data-placeholder="请选择仓库名称" ref="spmt_edit_store"></select>
				</div>
			</div>
			<div class="row">
				<label class="col-md-4">库存不足是否出货：</label>
				<div class="col-md-8 ct-col">
					<select class="form-control" data-placeholder="请选择是否出货" ref="spmt_edit_status">
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				showSpmt: true,
				modify: 1,
			}
		},
		watch: {
			
		},
		mounted: function() {
			this.initTable();
			this.getSpmtShop();
			$(this.$refs.spmt_edit_status).select2({
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			});
		},
		methods: {
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.spmtList).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getSpmtList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "25%"
					}, {
						field: "store_name",
						title: "名称",
						width: "25%"
					}, {
						field: "status",
						title: "库存不足是否出货",
						width: "25%",
						formatter: function(value, row, index) {
							if(row.status == '1') {
								return '是';
							} else if(row.status == '-1') {
								return '否';
							}
						}
					}, {
						title: "操作",
						width: "25%",
						events: {
							'click .modify': function(e, value, row) {
								_this.modify = '2';
								$(_this.$refs.spmt_edit_shop).val(row.shop_id).trigger('change');
								$(_this.$refs.spmt_edit_shop).prop('disabled', true);
								_this.getShopStore(row.shop_id);
								$(_this.$refs.spmt_edit_store).val(row.store_id).trigger('change');
								$(_this.$refs.spmt_edit_status).val(row.status).trigger('change');
								_this.spmtEdit('修改设置', row.id);
							},
							'click .del': function(e, value, row) {
								layer.confirm('删除后当前仓库的库存不足出货设置会失效，确定删除？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delSpmt(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue modify">修改</span><span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			// 列表
			getSpmtList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "store/getCheckStockList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取门店
			getSpmtShop: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							$(_this.$refs.spmt_edit_shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.getShopStore(e.params.data.id);
							});
							_this.getShopStore(shopDatas[0].id);
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			getShopStore: function(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data.response.result_code == "true") {
							let shopStore = [];
							$.each(data.response.result, function(k, v) {
								shopStore.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.spmt_edit_store).html('');
							$(_this.$refs.spmt_edit_store).select2({
								data: shopStore,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			addSpmt: function() {
				this.modify = '1';
				$(this.$refs.spmt_edit_shop).val('').trigger('change');
				$(this.$refs.spmt_edit_shop).prop('disabled', false);
				this.getShopStore($(this.$refs.spmt_edit_shop).val());
				$(this.$refs.spmt_edit_store).val('').trigger('change');
				$(this.$refs.spmt_edit_status).val('').trigger('change');
				this.spmtEdit('新增设置', '');
			},
			// 新增、修改
			spmtEdit: function(name, id) {
				let _this = this;

				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: [name, true],
					area: ['660px', ''],
					content: $(_this.$refs.spmt_edit),
					offset: '100px'
				}, function() {
					let url = Vue.ctUrl + "store/addCheckStock";
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"shop_id": $(_this.$refs.spmt_edit_shop).val(),
								"store_id": $(_this.$refs.spmt_edit_store).val(),
								"status": $(_this.$refs.spmt_edit_status).val()
							}
						},
						"comment": ""
					};
					if(_this.modify == '2') {
						datas["request"]["param"]["id"] = id;
						url = Vue.ctUrl + "store/editCheckStock";
					}
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: url,
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: datas2,
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.closeAll();
								$(_this.$refs.spmtList).bootstrapTable('refresh');
								layer.msg('操作成功');
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
			delSpmt: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "store/delCheckStock",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							layer.msg('删除成功');
							$(_this.$refs.spmtList).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.shipment-manage-wrap {
		.spmt-edit {
			display: none;
			width: 80%;
			margin: 20px auto;
			label {
				padding: 0;
				line-height: 32px;
				color: #5e5e5e;
				font-size: 14px;
				text-align: right;
				font-weight: normal;
			}
			.row {
				margin: 0 0 20px;
			}
			.icon-link {
				float: left;
				width: 5px;
				line-height: 32px;
			}
		}
	}
</style>